import React from 'react';
import { TextField, Slider, Switch, Button } from 'ceci-ui';
import { Container, FeesWrapper } from './styles';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';

const IssueChargeForm = () => {
  return (
    <Container>
      <h3>Nova cobrança</h3>

      <TextField
        placeholder="Procurar cliente" />
      <p>Escolha a periodicidade do pagamento:</p>
      <Slider />

      <p>Qual o valor a ser cobrado?</p>
      <TextField
        inputProps={{ style: { textAlign: 'right' } }}
        leftIcon={<span>R$</span>}
        placeholder="0,00" />


      <p>Escolha a data de vencimento:</p>
      <TextField
        inputProps={{ style: { textAlign: 'right' } }}
        leftIcon={<CalendarTodayIcon />}
        placeholder="21/12/2020" />

      <div className="spacer" />
      <TextField placeholder="Descrição" />

      <FeesWrapper>
        <span>Juros</span>
        <Switch />
      </FeesWrapper>

      <TextField
        inputProps={{ style: { textAlign: 'right' } }}
        leftIcon={<span>R$</span>}
        placeholder="0,00" />
      <div className="spacer" />

      <Button variant="contained" color="green">Gerar cobrança</Button>
    </Container>
  )
};

export default IssueChargeForm;
